(function () {
  if (window.__elemenceFlipCardInit) return;
  window.__elemenceFlipCardInit = true;

  var SELECTOR = '.elemence-ecard, .elemence-ecell';

  function bind(card) {
    if (card.dataset.flipBound) return;
    card.dataset.flipBound = '1';
    card.addEventListener('click', function (e) {
      if (e.target.closest('a, button, input, select, textarea, [data-no-flip]')) return;
      card.classList.toggle('is-flipped');
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
